import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';

const propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	color: PropTypes.string,
	checked: PropTypes.bool,
	onCheck: PropTypes.func,
	disabled: PropTypes.bool,
	label: PropTypes.object,
	labelPlacement: PropTypes.string,
	labelStyle: PropTypes.object,
};

const MaterialCheckbox = ({
	id,
	color = 'primary',
	checked = false,
	onCheck,
	disabled = false,
	label = '',
	labelPlacement = 'end',
	labelStyle,
	...rest
}) => (
	<FormControlLabel
		control={(
			<Checkbox
				id={id}
				checked={checked}
				onChange={onCheck}
				color={color}
				disabled={disabled}
				{...rest}
			/>
		)}
		label={label}
		labelPlacement={labelPlacement}
		style={labelStyle}
	/>
);

MaterialCheckbox.muiName = 'Checkbox';
MaterialCheckbox.displayName = Checkbox.muiName;

MaterialCheckbox.propTypes = propTypes;

export default MaterialCheckbox;
